









import Vue from 'vue'
export default Vue.extend({
  name: 'UiProgress',
  props: {
    prcnt: {
      type: Number,
      default: 0
    },
    showNumber: {
      type: Boolean,
      default: true
    }
  }
})
